var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        height: 25,
        width: 180,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: { x: "0", y: "5", rx: "0", ry: "0", width: "50", height: "5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "0",
          y: "12",
          rx: "0",
          ry: "0",
          width: "180",
          height: "15",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }